<!-- 多选组件 -->
<template>
<div class="multipleSelect flex_align">
    <ul class="selectList">
        <li class="item" :class="{'active':isAll}" @click="selectAll">不限</li>
        <li
            class="item"
            :class="{'active':selected.indexOf(valueType=='label'?option.label:option.value)!=-1&&!isAll}"
            v-for="(option,index) in selection" :key="index"
            @click="selectOption(valueType=='label'?option.label:option.value)">
            {{option.label}}
        </li>
    </ul>
</div>
</template>

<script>
    export default {
        data() {
            return {
                selected:[],
            }
        },
        computed: {
            isAll(){
                if(!this.selected.length||this.selected.length==this.selection.length){
                    return true;
                }
                return false;
            },
            emitData(){
                return {
                    key:this.paramKey,
                    data:this.selected
                }
            }
        },
        watch: {
            isAll(){
                if(this.isAll){
                    this.selected=[]
                }
            },
            selectedProp(){
                console.log(1111,this.selectedProp)
                this.selected=this.selectedProp
            }
        },
        props:{
            valueType:{//确定 值为value还是label
                type:String,
                default(){
                    return 'value';
                }
            },
            paramKey:{//后台传参的key
                type:String,
                default(){
                    return 'key';
                }
            },
            selection:{
                type:Array,
                default(){
                    return [];
                }
            },
            selectedProp:{
                type:Array,
                default(){
                    return [];
                }
            }
        },
        created() {
            // this.selected=this.selectedProp
        },
        methods: {
            selectOption(val){
                // console.log(this.selected)
                let n = this.selected.indexOf(val)
                if(n!=-1){
                    this.selected.splice(n,1)
                }else{
                    this.selected.push(val)
                }
                this.$emit('selectOption',this.emitData);
            },
            selectAll(){
                this.selected=[];
                this.$emit('selectOption',this.emitData);
            }
        }
    }
</script>

<style lang="scss" scoped>
.multipleSelect{
    height: 100%;
}
</style>
